import { activeDiagnostics, streamInspectorOpen } from '../state/diagnostics';

interface Props {
  className?: string;
}

export function StreamBadge({ className = '' }: Props) {
  const diag = activeDiagnostics.value;
  if (!diag) return null;

  const codecLabel = diag.codec.toUpperCase();
  const bitrateLabel = diag.bitrateKbps ? `${diag.bitrateKbps}k` : '';
  const label = [codecLabel, bitrateLabel].filter(Boolean).join(' · ');

  return (
    <button
      type="button"
      class={`stream-badge ${className}`}
      onClick={() => {
        streamInspectorOpen.value = true;
      }}
      aria-label="View stream diagnostics"
      title={`Stream: ${label} (Click for diagnostics)`}
    >
      <span class="stream-badge__indicator" aria-hidden="true" />
      <span class="stream-badge__text">{label || 'AUDIO'}</span>
    </button>
  );
}
